<cm-sidebar-layout>
    <cm-item-filters cm-filters>
        <cm-tag-search-filter placeholder="Name, email, ..."></cm-tag-search-filter>
        <cm-checkboxes-filter label="State" name="dataObjectState" [options]="Labels.DataObjectState"></cm-checkboxes-filter>
        <cm-checkboxes-filter label="Relation to other files" name="isRelated" [options]="Labels.IsRelated"></cm-checkboxes-filter>
    </cm-item-filters>
    <cm-files-grid></cm-files-grid>
</cm-sidebar-layout>
<router-outlet></router-outlet>
